import {
  GraphImage,
  HourglassImage,
  LogImage,
  PersonImage,
  PulseImage,
} from 'Assets/Image/Icons'

export const WHAT_WE_STAND_FOR_ITEMS = [
  {
    id: 'Impact over Hype',
    icon: GraphImage,
    title: 'Impact over Hype',
    caption:
      'We choose proven tools and real outcomes - no buzzwords, no throwaway builds.',
  },
  {
    id: 'Think Like Owners',
    icon: LogImage,
    title: 'Think Like Owners',
    caption:
      'We act like your partner, not a vendor. Every dollar, deadline, and deliverable matters.',
  },
  {
    id: 'Build Fast. Scale Clean.',
    icon: HourglassImage,
    title: 'Build Fast. Scale Clean.',
    caption:
      'Speed is our strength, but never at the cost of tech debt or long-term pain.',
  },
  {
    id: 'Keep it Human',
    icon: PersonImage,
    title: 'Keep it Human',
    caption:
      "We're engineers, but we speak business. We value clarity, empathy, and mutual respect.",
  },
  {
    id: 'Always Ship Value',
    icon: PulseImage,
    title: 'Always Ship Value',
    caption: 'Every sprint moves the product forward. No fluff. No filler.',
  },
]
